import { urlManger } from "@/url/common";
import { EntityUrl } from "@intasect/platform-core";
export const url_configurationModel: EntityUrl = {
  
    get page() {
        return `${urlManger.getServiceUrl("user")}/cmb/request-permission/findListPage`;
    },
  
};
